// import DefaultPhoneInput, {
//   formatPhoneNumber,
//   formatPhoneNumberIntl,
// } from "react-phone-number-input";
// import "react-phone-number-input/style.css";
// import "./style.css";

// type DefaultPhoneInputProps = typeof DefaultPhoneInput;
// type PhoneInputProps = DefaultPhoneInputProps & {
//   name?: string;
//   value?: string;
//   className?: string;
//   onChange?: (payload: { dialCode: string; phone: string }) => void;
//   placeholder?: string;
//   required?: boolean;
//   disabled?: boolean;
// };

// const PhoneInput: React.FC<PhoneInputProps> = (props: PhoneInputProps) => {
//   return (
//     <DefaultPhoneInput
//       {...props}
//       defaultCountry={"CA"}
//       countryOptionsOrder={["CA", "IN", "US", "PK"]}
//       value={props?.value}
//       className={`w-[100%] border-slate-300/100 text-sm text-slate-500 ${props?.className}`}
//       limitMaxLength={true}
//       placeholder={props?.placeholder}
//       focusInputOnCountrySelection
//       required={props?.required}
//       onChange={(val) => {
//         let code = formatPhoneNumberIntl(val || "");
//         code = code?.substring(0, code?.indexOf(" "));
//         props?.onChange &&
//           props?.onChange({
//             phone: val?.replace(code, "") || "",
//             dialCode: code,
//           });
//       }}
//       aria-label="#Phone"
//     />
//   );
// };

// export default PhoneInput;

// import React, { useState, useEffect } from "react";
// import "./style.css";

// type PhoneInputProps = {
//   name?: string;
//   value?: string;
//   className?: string;
//   onChange?: (payload: { dialCode: string; phone: string }) => void;
//   placeholder?: string;
//   required?: boolean;
//   disabled?: boolean;
//   error?: boolean;
// };

// // Country code data
// const COUNTRY_CODES = [
//   { code: "CA", name: "Canada", dialCode: "+1" },
//   { code: "US", name: "United States", dialCode: "+1" },
//   { code: "IN", name: "India", dialCode: "+91" },
//   { code: "PK", name: "Pakistan", dialCode: "+92" },
//   { code: "GB", name: "United Kingdom", dialCode: "+44" },
//   { code: "AU", name: "Australia", dialCode: "+61" },
//   { code: "SG", name: "Singapore", dialCode: "+65" },
//   { code: "NZ", name: "New Zealand", dialCode: "+64" },
//   { code: "ZA", name: "South Africa", dialCode: "+27" },
// ];

// const PhoneInput: React.FC<PhoneInputProps> = ({
//   value = "",
//   className = "",
//   onChange,
//   placeholder = "Enter phone number",
//   required = false,
//   disabled = false,
//   name,
//   error = false,
// }) => {
//   // Extract dial code and phone from value prop
//   const dialCodeFromValue = value?.match(/^\+\d+/)?.[0] || "";
//   const phoneNumberFromValue = value?.replace(/^\+\d+/, "") || "";

//   // Local state for controlled component
//   const [selectedDialCode, setSelectedDialCode] = useState(dialCodeFromValue);
//   const [phoneNumber, setPhoneNumber] = useState(phoneNumberFromValue);
//   console.log("Dial code from value is ", dialCodeFromValue);
//   // Sync state when value prop changes (for controlled component)
//   useEffect(() => {
//     setSelectedDialCode(dialCodeFromValue);
//     setPhoneNumber(phoneNumberFromValue);
//   }, [value]);

//   const handleCountryChange = (
//     e: React.ChangeEvent<HTMLSelectElement>
//   ) => {
//     const newDialCode = e.target.value;
//     setSelectedDialCode(newDialCode);
//     console.log("handle coutry change ", newDialCode);

//     // Trigger onChange with new dial code and current phone
//     onChange?.({
//       dialCode: newDialCode,
//       phone: phoneNumber,
//     });
//   };

//   const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const phoneValue = e.target.value;
//     setPhoneNumber(phoneValue); 

//     // Trigger onChange with current dial code and NEW phone value
//     onChange?.({
//       dialCode: selectedDialCode,
//       phone: phoneValue, 
//     });
//   };

//   return (
//     <div className={`flex gap-2 w-full ${className}`}>
//       {/* Country Code Dropdown */}
//       <select
//         value={selectedDialCode}
//         onChange={handleCountryChange}
//         disabled={disabled}
//         required={required}
//         className={`border rounded px-2 py-2 text-sm text-slate-700 bg-white focus:outline-none focus:ring-2 focus:border-transparent disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed min-w-[80px] w-[80px] ${
//           error
//             ? "border-red-500 focus:ring-red-500"
//             : "border-slate-300 focus:ring-blue-500"
//         }`}
//         aria-label="Country Code"
//       >
//         <option value="">Code</option>
//         {COUNTRY_CODES.map(({ code, name, dialCode }) => (
//           <option key={dialCode} value={dialCode}>
//             {name} ({dialCode})
//           </option>
//         ))}
//       </select>

//       {/* Phone Number Input */}
//       <input
//         type="tel"
//         name={name}
//         value={phoneNumber}
//         onChange={handlePhoneChange}
//         placeholder={placeholder}
//         disabled={disabled}
//         required={required}
//         className={`flex-1 border rounded px-3 py-2 text-sm text-slate-700 placeholder-slate-400 focus:outline-none focus:ring-2 focus:border-transparent disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed ${
//           error
//             ? "border-red-500 focus:ring-red-500"
//             : "border-slate-300 focus:ring-blue-500"
//         }`}
//         aria-label="Phone Number"
//       />
//     </div>
//   );
// };

// export default PhoneInput;

import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import ErrorMessage from "src/base-components/FormErrorValidation/ErrorMessage";

type PhoneInputProps = {
  name?: string;
  value?: string;
  className?: string;
  onChange?: (payload: { dialCode: string; phone: string }) => void;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  dialCodeError?: boolean;
  phoneError?: boolean;
  setDialCodeError?: any;
  setPhoneNumberError?: any;
  errorPhone?: any;
  setErrorPhone?: any;
};

const COUNTRY_CODES = [
  { code: "US", name: "United States", dialCode: "+1", min: 10, max: 10 },
  { code: "CA", name: "Canada", dialCode: "+1", min: 10, max: 10 },
  { code: "IN", name: "India", dialCode: "+91", min: 10, max: 10 },
  { code: "GB", name: "United Kingdom", dialCode: "+44", min: 10, max: 10 },
  { code: "AU", name: "Australia", dialCode: "+61", min: 9, max: 9 },
  { code: "NZ", name: "New Zealand", dialCode: "+64", min: 9, max: 9 },
  { code: "SG", name: "Singapore", dialCode: "+65", min: 8, max: 8 },
  { code: "AE", name: "UAE", dialCode: "+971", min: 9, max: 9 },
  { code: "SA", name: "Saudi Arabia", dialCode: "+966", min: 9, max: 9 },
  { code: "PK", name: "Pakistan", dialCode: "+92", min: 10, max: 10 },
  { code: "BD", name: "Bangladesh", dialCode: "+880", min: 10, max: 10 },
  { code: "NP", name: "Nepal", dialCode: "+977", min: 10, max: 10 },
  { code: "LK", name: "Sri Lanka", dialCode: "+94", min: 9, max: 9 },
  { code: "CN", name: "China", dialCode: "+86", min: 11, max: 11 },
  { code: "JP", name: "Japan", dialCode: "+81", min: 10, max: 11 },
  { code: "KR", name: "South Korea", dialCode: "+82", min: 9, max: 11 },
  { code: "TH", name: "Thailand", dialCode: "+66", min: 9, max: 10 },
  { code: "ID", name: "Indonesia", dialCode: "+62", min: 9, max: 12 },
  { code: "PH", name: "Philippines", dialCode: "+63", min: 10, max: 10 },
  { code: "MY", name: "Malaysia", dialCode: "+60", min: 9, max: 10 },
  { code: "DE", name: "Germany", dialCode: "+49", min: 10, max: 11 },
  { code: "FR", name: "France", dialCode: "+33", min: 9, max: 9 },
  { code: "IT", name: "Italy", dialCode: "+39", min: 9, max: 10 },
  { code: "ES", name: "Spain", dialCode: "+34", min: 9, max: 9 },
  { code: "NL", name: "Netherlands", dialCode: "+31", min: 9, max: 9 },
  { code: "BE", name: "Belgium", dialCode: "+32", min: 9, max: 9 },
  { code: "CH", name: "Switzerland", dialCode: "+41", min: 9, max: 9 },
  { code: "SE", name: "Sweden", dialCode: "+46", min: 9, max: 9 },
  { code: "NO", name: "Norway", dialCode: "+47", min: 8, max: 8 },
  { code: "DK", name: "Denmark", dialCode: "+45", min: 8, max: 8 },
  { code: "FI", name: "Finland", dialCode: "+358", min: 9, max: 10 },
  { code: "RU", name: "Russia", dialCode: "+7", min: 10, max: 10 },
  { code: "TR", name: "Turkey", dialCode: "+90", min: 10, max: 10 },
  { code: "BR", name: "Brazil", dialCode: "+55", min: 10, max: 11 },
  { code: "MX", name: "Mexico", dialCode: "+52", min: 10, max: 10 },
  { code: "AR", name: "Argentina", dialCode: "+54", min: 10, max: 11 },
  { code: "CL", name: "Chile", dialCode: "+56", min: 9, max: 9 },
  { code: "CO", name: "Colombia", dialCode: "+57", min: 10, max: 10 },
  { code: "PE", name: "Peru", dialCode: "+51", min: 9, max: 9 },
  { code: "ZA", name: "South Africa", dialCode: "+27", min: 9, max: 9 },
  { code: "NG", name: "Nigeria", dialCode: "+234", min: 10, max: 11 },
  { code: "KE", name: "Kenya", dialCode: "+254", min: 9, max: 10 },
  { code: "EG", name: "Egypt", dialCode: "+20", min: 10, max: 10 },
];

const MAX_PHONE_LENGTH = 20;

const splitValue = (value: string): { dialCode: string; phone: string } => {
  const trimmed = (value || "").trim();
  if (!trimmed) return { dialCode: "", phone: "" };

  const spaceIndex = trimmed.indexOf(" ");
  if (spaceIndex !== -1 && trimmed.startsWith("+")) {
    return {
      dialCode: trimmed.slice(0, spaceIndex),
      phone: trimmed.slice(spaceIndex + 1).trim(),
    };
  }

  if (trimmed.startsWith("+")) {
    const knownCode = COUNTRY_CODES.find((c) => trimmed.includes(c.dialCode));
    if (knownCode) return { dialCode: knownCode.dialCode , phone: trimmed.slice(knownCode.dialCode.length) };
  }

  return { dialCode: "", phone: trimmed };
};

const PhoneInput: React.FC<PhoneInputProps> = ({
  value = "",
  className = "",
  onChange,
  placeholder = "Enter phone number",
  required = false,
  disabled = false,
  name,
  dialCodeError = false,
  phoneError = false,
  setDialCodeError,
  setPhoneNumberError,
  errorPhone = "",
  setErrorPhone
}) => {
  const parsed = splitValue(value);

  const [selectedDialCode, setSelectedDialCode] = useState(parsed.dialCode);
  const [phoneNumber, setPhoneNumber] = useState(parsed.phone);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const internalChangeRef = useRef(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (internalChangeRef.current) {
      internalChangeRef.current = false;
      return;
    }
    const next = splitValue(value);
    setSelectedDialCode(next.dialCode);
    setPhoneNumber(next.phone);
  }, [value]);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // const handleCountrySelect = (dialCode: string) => {
  //   setSelectedDialCode(dialCode);
  //   setIsDropdownOpen(false);
  //   internalChangeRef.current = true;
  //   onChange?.({ dialCode, phone: phoneNumber });
  // };

  // const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const digitsOnly = e.target.value
  //     .replace(/\D/g, "")
  //     .slice(0, MAX_PHONE_LENGTH);
  //   setPhoneNumber(digitsOnly);
  //   internalChangeRef.current = true;
  //   onChange?.({ dialCode: selectedDialCode, phone: digitsOnly });
  // };

  const handleCountrySelect = (dialCode: string) => {
    if (!dialCode) {
      setDialCodeError && setDialCodeError(true);
      // return;
    }
    else{
      setDialCodeError && setDialCodeError(false);
    }
    setSelectedDialCode(dialCode);
    setIsDropdownOpen(false);
    internalChangeRef.current = true;
    if (phoneNumber.length > 0) {
      for (const data of COUNTRY_CODES) {
        if (data.dialCode === dialCode) {
          if (phoneNumber.length < data.max || phoneNumber.length > data.max) {
            setPhoneNumberError && setPhoneNumberError(true);
            setErrorPhone && setErrorPhone("Please enter a valid number");
            return;
          }
          else {
            setPhoneNumberError && setPhoneNumberError(false);
            onChange?.({ dialCode, phone: phoneNumber });
            return;
          }
        }
      }
    }
    else {
      setPhoneNumberError && setPhoneNumberError(true);
      onChange?.({ dialCode, phone: phoneNumber });
    }
  }

  const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value.startsWith("+")) {
      for (const data of COUNTRY_CODES) {
        if (value.includes(data.dialCode)) {
          const realValue = value.substring(data.dialCode.length).replace(/\D/g, "");
          if (realValue.length >= data.min && realValue.length <= data.max) {
            setPhoneNumber && setPhoneNumber(realValue);
            setSelectedDialCode && setSelectedDialCode(data.dialCode);
            internalChangeRef.current = true;
            setPhoneNumberError && setPhoneNumberError(false);
            onChange?.({ dialCode: data.dialCode, phone: realValue });
            return;
          }
          else {
            setPhoneNumberError && setPhoneNumberError(true);
            setErrorPhone("Fill the correct number");
            return;
          }
        }
      }
      setPhoneNumberError && setPhoneNumberError(true);
      setErrorPhone && setErrorPhone("Fill the Correct Country Code");
      return;
    }
    else if (selectedDialCode) {
      const digitsOnly = value.replace(/\D/g, "");
      for (const data of COUNTRY_CODES) {
        if (selectedDialCode === data.dialCode) {
          if (digitsOnly.length < data.min || digitsOnly.length > data.max) {
            setPhoneNumberError && setPhoneNumberError(true);
            setErrorPhone && setErrorPhone("Please enter a valid number");
          }
          else {
            setPhoneNumberError && setPhoneNumberError(false);
            setErrorPhone && setErrorPhone("");
          }
        }
      }
      setPhoneNumber && setPhoneNumber(digitsOnly);
      internalChangeRef.current = true;
      onChange?.({ dialCode: selectedDialCode, phone: digitsOnly });
    }
    else {
      const digitsOnly = value.replace(/\D/g, "");
      setPhoneNumber && setPhoneNumber(digitsOnly);
      internalChangeRef.current = true;
      onChange?.({ dialCode: selectedDialCode, phone: digitsOnly });
    }

    if(!selectedDialCode){
      setDialCodeError && setDialCodeError(true);
    }
    else{
      setDialCodeError && setDialCodeError(false);
    }
  }

  return (
    /**
     * Outer: flex-row so dial-code col and phone col sit side by side.
     * items-start: each column anchors to the TOP — errors grow
     * downward and NEVER push siblings in the parent row.
     * The className from the parent controls outer width (e.g. w-[40%]).
     */
    <div className={`flex items-start ${className}`}>

      {/* ── Dial Code Column ─────────────────────────── */}
      <div className="flex flex-col">
        <div className="relative" ref={dropdownRef}>
          <button
            type="button"
            disabled={disabled}
            aria-label="Country Code"
            onClick={() => !disabled && setIsDropdownOpen((prev) => !prev)}
            className={[
              "border border-slate-300/100 rounded px-2 text-sm text-slate-700 bg-white",
              "focus:outline-none focus:border-primary focus:border-opacity-40",
              "disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed",
              "w-[76px] h-[38px] flex items-center justify-between gap-1",
              dialCodeError && "border-danger",
            ].join(" ")}
          >
            <span className="font-medium truncate text-xs leading-none">
              {selectedDialCode || "Code"}
            </span>
            <svg
              className={`w-3 h-3 flex-shrink-0 transition-transform duration-150 ${isDropdownOpen ? "rotate-180" : ""
                }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {/* Absolutely positioned — ZERO impact on layout flow */}
          {isDropdownOpen && (
            <div className="absolute top-[calc(100%+4px)] left-0 w-56 bg-white border border-slate-200 rounded-md shadow-xl z-50 max-h-60 overflow-y-auto">
              <div className="p-1">
                <button
                  type="button"
                  onClick={() => handleCountrySelect("")}
                  className="w-full text-left px-3 py-2 text-xs text-slate-400 hover:bg-slate-50 rounded"
                >
                  — Select Code —
                </button>
                {COUNTRY_CODES.map(({ code, name, dialCode }) => (
                  <button
                    key={code}
                    type="button"
                    onClick={() => handleCountrySelect(dialCode)}
                    className={[
                      "w-full text-left px-3 py-2 text-xs rounded transition-colors",
                      selectedDialCode === dialCode
                        ? "bg-blue-50 text-blue-800 font-semibold"
                        : "text-slate-700 hover:bg-slate-50",
                    ].join(" ")}
                  >
                    {name} ({dialCode})
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/*
          Error slot — always occupies the same height so the
          dial-code column height is predictable.
          min-h-[20px] reserves space even when no error is shown.
        */}
        <div className="min-h-[20px] mt-0.5">
          {dialCodeError && (
            <ErrorMessage message="Select code" />
          )}
        </div>
      </div>

      {/* ── Phone Number Column ───────────────────────── */}
      <div className="flex flex-col flex-1">
        <input
          type="tel"
          name={name}
          value={phoneNumber}
          onChange={handlePhoneChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          maxLength={MAX_PHONE_LENGTH}
          inputMode="numeric"
          aria-label="Phone Number"
          className={[
            "transition duration-200 ease-in-out border border-slate-300/100 shadow-sm rounded-md text-sm bg-white",
            "focus:outline-none focus:ring-4 focus:ring-primary focus:ring-opacity-20 focus:border-primary focus:border-opacity-40",
            "disabled:bg-slate-100 disabled:text-slate-500 disabled:cursor-not-allowed",
            " h-[38px] flex items-center justify-between gap-1 px-2",
            phoneError && "border-danger",
          ].join(" ")}
        />

        {/*
          Same reserved error slot as dial code column — both columns
          always have the same total height whether error shows or not.
        */}
        <div className="min-h-[20px] mt-0.5">
          {phoneError && (
            <ErrorMessage message={errorPhone} />
          )}
        </div>
      </div>
    </div>
  );
};

export default PhoneInput;